// import { FC, forwardRef } from 'react';
import { FC, ReactNode } from 'react';
import { CardProps } from 'antd';

import styles from './box.module.scss';

export interface BoxProps extends CardProps {
  children?: React.ReactNode;
  style?: any;
  title?: string | ReactNode;
  padding?: number | string;
  borderRadius?: number | string;
  component?: React.ElementType;
  ref?: React.Ref<HTMLDivElement>;
}

export const Box: FC<BoxProps> = ({
  title,
  children,
  padding,
  borderRadius,
  style,
  className,
  ref,
  ...props
}) => {
  return (
    <div
      ref={ref}
      className={`${styles.box}${className ? ` ${className}` : ''}`}
      style={{ padding: padding, borderRadius: borderRadius, ...style }}
      {...(props as any)}
    >
      {title ? <div className={styles.title}>{title}</div> : null}
      <div className={styles.content}>{children}</div>
    </div>
  );
};

Box.displayName = 'Box';
